import { createReducer } from '@reduxjs/toolkit'; // TODO: import from `~/lib/redux` instead
import { getTeams } from '../../redux';
const initialState = {
    teams: [],
    total: 0,
    error: null,
    isLoading: false,
};
const teams = createReducer(initialState, (builder) => {
    builder
        .addCase(getTeams.request, (state) => {
        state.isLoading = true;
        state.error = null;
    })
        .addCase(getTeams.success, (state, action) => {
        const { data: { data, total } } = action.payload;
        state.teams = data.map(({ team_id: id, team_name: name, area_id: areaId, area_name: areaName, boundary: hasBoundary, statistics: { total_reps: totalReps, active_customers: activeCustomers, inactive_customers: inactiveCustomers, total_qualified_addresses: totalQualifiedAddresses, }, }) => ({
            id,
            name,
            areaId,
            areaName,
            hasBoundary,
            totalReps,
            activeCustomers,
            inactiveCustomers,
            totalQualifiedAddresses,
        }));
        state.total = total;
        state.isLoading = false;
    });
});
export default teams;
